import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class Tooltip {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.tooltip'), el => {
            new Tooltip(el);
        });
    }

    tooltipBox = document.createElement('DIV');
    tooltipBoxCloseButton = document.createElement('BUTTON');

    constructor(element) {
        if (!element || !element.dataset || !element.dataset.text) return;

        let isMobile = window.innerWidth < 768;
        this.tooltipBoxCloseButton.classList.add('tippy-box__close');

        this.tooltip = tippy(element, {
            interactive: true,
            content: `<div class="tippy-content__inner">${element.dataset.text}</div>` + this.tooltipBoxCloseButton.outerHTML,
            allowHTML: true,
            boundary: 'viewport',
            maxWidth: 'inherit',
            trigger: isMobile ? 'click' : 'mouseenter click',
            // Either use this...
            popperOptions: {
                strategy: 'fixed',
            },
            // or
            // appendTo: () => document.body,
        });

        window.addEventListener('click', e => {
            if (e.target.classList && e.target.classList.contains('tippy-box__close')) this.tooltip.hide();
        });
    }
}
